import React from 'react';
import filter from '../../filter';
import ListStats from '../ListStats';
import ListTable from '../ListTable';
import ListResults from '../ListResults';
import Print from '../Print';
import shallowequal from 'shallowequal';
import Alert from "../Alert";
import { executeQuery } from "../../requests/executeQuery";
import { manageData } from "../../requests/CRUD";
import { PROPERTIES } from "../../consts/tables";
import { V8_PROPERTIES_LIST, V7_PROPERTIES_LIST, V7_PROPERTIES_STATS, V7_PROPERTIES_STATS_ACTIVE, V7_PROPERTIES_STATS_COUNT } from '../../consts/queries';
import LinkComp from '../LinkComp';
import hscTeamMembers from '../../hsc-team-members';
import Icon from '../Icon';
import plus from '../../svgs/plus-white.svg';
import trash from '../../svgs/Trash.svg'
import Dropdown from '../Dropdown/Dropdown';
import ConfirmationDialog from "../../components/ConfirmDialog";
import { V10_PROPERTIES_LIST, V10_PROPERTIES_STATS_ACTIVE, V10_PROPERTIES_STAT_COUNT, V7_PROPERTIES_LIST_DEV, V7_PROPERTIES_STATS_ACTIVE_DEV, V7_PROPERTIES_STATS_QUERY, V7_PROPERTIES_STAT_COUNT, V9_PROPERTIES_LIST, V9_PROPERTIES_STATS_ACTIVE, V9_PROPERTIES_STAT_COUNT } from '../Graphql/Queries/propertiesQuery';
import { ApolloConsumer } from '@apollo/client';
import { DELETE_PROPERTIES } from '../Graphql/Mutations/propertiesMutation';
import { fetchData } from '../Service/graphQlService';
import { isAgentUser, updateParams, groupObjectByIndex } from '../../utils';
import {
    computePropertyListStats,
    fetchGroupPropertyListItems,
    fetchRecordGroupMemberIds,
    stripRecordGroupListOptions,
} from '../RecordGroups/recordGroupsService';

let cloneDeep = require('lodash.clonedeep');
const limit = 100;

export default class Listing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            showConfirm: false,
            uniquePropCount: 0,
            originalItems: [],
            totalCount: 0,
            stats: null,
            error: null,
            isBusy: null,
            query: this.props.location && this.props.location.query ? this.props.location.query : {},
            hscquery: {},
            underwritingSuccess: false,
            underwritingError: false,
            selectedNo: 0,
            unselectedNo: 0,
            areRemovedItems: false,
            selectionStats: false,
            comps: '',
            selectedAll: false,
            lastVisited: ''
        };
        this.client = null

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.removeSelected = this.removeSelected.bind(this);
        this.removeUnselected = this.removeUnselected.bind(this);
        this.reset = this.reset.bind(this);
        this.updateStats = this.updateStats.bind(this);
        this.deleteSelected = this.deleteSelected.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.onCloseConfirm = this.onCloseConfirm.bind(this);
        this.selectSaleComps = this.selectSaleComps.bind(this);
        this.selectLeaseComps = this.selectLeaseComps.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    componentDidMount() {
        let queries =
          this.props.location && this.props.location.query
            ? this.props.location.query
            : {};
        let lastVisited = sessionStorage.getItem('lastClickedProperty');
        this.setState({ lastVisited })
        Listing.rememberListUrl();
        if (this.client) {
            this.fetch(queries);
        }
        window.history.replaceState(null, '');

        let hscquery = {
            hsc_team_members: ''
        };
      let member =
        this.props &&
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.hsc_team_members
          ? this.props.location.query.hsc_team_members.split(",")
          : [];
        const memberList = hscTeamMembers.filter((e) => {
            return member.indexOf(e.EMAIL) >= 0;
        })
        memberList.map((el, index) => {
            hscquery.hsc_team_members += el ? index === hscTeamMembers.length - 1 ? el.EMAIL : el.EMAIL + ',' : '';
        })
        this.setState({ hscquery });

    }

    // Property detail page's PROPERTIES link returns to the last search (filters live in the URL).
    static rememberListUrl() {
        try {
            localStorage.setItem('lastPropertiesListUrl', window.location.pathname + window.location.search);
        } catch (e) { }
    }

    static getOptions(query, page) {
        const options = filter(query, page);
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;
        return options;
    }

    static setQueryOrder(q) {
        const query = { ...q };
        if (query.source && query.source.toLowerCase() === 'strive' &&
            (query.status && query.status.toLowerCase() === 'closed' || query.hsc_status && query.hsc_status.toLowerCase() === 'closed')) {
            if (Array.isArray(query.order) && query.order.indexOf('close_of_escrow.desc') === -1) {
                query.order.push('close_of_escrow.desc');
                return query;
            }
            if (!query.order) {
                query.order = 'close_of_escrow.desc';
            }
        }
        return query;
    }
    //#region New code
     updateStatus(params) {
        if (params) {
            if(params.status_1 && params.status_2 && params.status_3 && params.status_4 && params.status_5 && params.status_6 && params.status_7 && params.status_8){
                params.status = [];
                for (let i = 1; i <= 8; i++) {
                    let statusKey = `status_${i}`;
    
                    // Check if the status value is not "NOMATCH" and has a value
                    if (params[statusKey] !== "NOMATCH") {
                        params.status.push(params[statusKey]);  // Add the status value to SOURCE array
                    }
                }
                for (let i = 1; i <= 8; i++) {
                    delete params[`status_${i}`];
                }
                return params;
            }
            else{
                const hscStatuses = [];    // from BE hsc_statuse payload changes 
                const result = {};
                params.hscStatuses = [];
                for (const key in params) {
                    if (key.startsWith("hsc_status_")) {
                        if (params[key] !== "NOMATCH") {
                            hscStatuses.push(params[key]);
                        }
                    } else {
                        result[key] = params[key];
                    }
                }
 
                result.hscStatuses = hscStatuses;
                  return result;
            }
           
        }
    }
    updateCategory(params) {
        if (params) {
            if(params.category_1 && params.category_2 && params.category_3 && params.category_4 && params.category_5){
                params.category = [];
                for (let i = 1; i <= 5; i++) {
                    let categoryKey = `category_${i}`;
    
                    // Check if the status value is not "NOMATCH" and has a value
                    if (params[categoryKey] !== "NOMATCH") {
                        params.category.push(params[categoryKey]);  // Add the status value to SOURCE array
                    }
                }
                for (let i = 1; i <= 5; i++) {
                    delete params[`category_${i}`];
                }
                return params;
            }
            else{
                return params
            }
           
        }
    }

    updateZip(params) {
        if (params) {
            const allZipExist = Array.from({ length: 120 }, (_, i) => params[`zip_${i + 1}`]).every(Boolean);
            if(allZipExist){
                params.zip = [];
                for (let i = 1; i <= 120; i++) {
                    let zipKey = `zip_${i}`;
    
                    // Check if the status value is not "NOMATCH" and has a value
                    if (params[zipKey] !== "NOMATCH") {
                        params.zip.push(params[zipKey]);  // Add the status value to SOURCE array
                    }
                }
                for (let i = 1; i <= 120; i++) {
                    delete params[`zip_${i}`];
                }
                return params;
            }
            else{
                return params;
            }
        }
    }
    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field.toLowerCase(),
                    order: order.toLowerCase()
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field.toLowerCase(),
                order: order.toLowerCase()
            }];
        }
        else{
            return [];
        }

    }

    fetch(q) {
        this.setState({ isBusy: true });

        let query = Listing.setQueryOrder(q);
        if (!query.order && q.source === "STRIVE" && q.status === "Active" && q.transaction_type === "Investment Sales") {
            let order = "Listed_date.desc";
            query = { ...query, order };
        }

        const ownerAgentId = this.props.userData && this.props.userData.id;
        const groupFilterPromise = query.group_id && ownerAgentId
            ? fetchRecordGroupMemberIds('property', ownerAgentId, query.group_id)
            : Promise.resolve(null);

        groupFilterPromise.then((groupMemberIds) => {
        this.runListingFetch(query, groupMemberIds, ownerAgentId);
        }).catch(() => {
        this.runListingFetch(query, query.group_id ? [] : null, ownerAgentId);
        });
    }

    runListingFetch(query, groupMemberIds, ownerAgentId) {
        const isGroupFilterActive = !!(query.group_id && ownerAgentId);
        if (isGroupFilterActive && (!groupMemberIds || !groupMemberIds.length)) {
            this.setState({
                originalItems: [],
                items: [],
                uniquePropCount: 0,
                totalCount: 0,
                stats: computePropertyListStats([]),
                error: null,
                isBusy: null,
                query,
                underwritingSuccess: false,
                underwritingError: false,
                selectedNo: 0,
                unselectedNo: 0,
            });
            return;
        }

        let page = 'properties';
        let statsQueryName = query.hasOwnProperty('source') && query.source === 'STRIVE' && query.hasOwnProperty('STATUS') && query.status === 'Active' ? V7_PROPERTIES_STATS_ACTIVE_DEV : V7_PROPERTIES_STATS_QUERY;
        let propertiesQueryName = V7_PROPERTIES_LIST_DEV;
        let countQueryName = V7_PROPERTIES_STAT_COUNT;
        let responseListKey = 'v7PropertiesList'
        let responseStatsKey = query.hasOwnProperty('source') && query.source === 'STRIVE' && query.hasOwnProperty('STATUS') && query.status === 'Active' ? 'v7PropertiesStatsActive' : 'v7PropertiesStats';
        let responseCountKey = 'v7PropertiesStatsCount'
        // if(query.hasOwnProperty('territory_listing_agent_team')&&!['Territory1','Territory2','Territory3','Territory4'].includes(query.territory_listing_agent_team)){
        //     delete query.hscStatuses
        //     page = 'territories'
        //     statsQueryName = V9_PROPERTIES_STATS_ACTIVE;
        //     countQueryName = V9_PROPERTIES_STAT_COUNT;
        //     propertiesQueryName = V9_PROPERTIES_LIST;
        //     responseListKey = 'v9PropertiesList'
        //     responseStatsKey = 'v9PropertiesStatsActive';
        //     responseCountKey = 'v9PropertiesStatsCount'
        //     /* Retriving the category and type from product type */
        //     if(query.hasOwnProperty('product_type')){
        //         const _types = new Set();
        //         const _categories = new Set();
        //         query.product_type.split(',').forEach((product)=>{
        //             let _type = product.split(' ')
        //             if(_type.length === 2){
        //                 _categories.add(_type[1]);
        //                 _types.add(_type[0]);
        //             }
        //         })
        //         let category = '';
        //         let type = '';
        //         _categories.forEach((key)=>{category = category+','+key});
        //         _types.forEach((key)=>{type = type+','+key});
        //         category = category.replace(/^,|,$/g, '')
        //         type = type.replace(/^,|,$/g, '')
        //         if(_types.size > 0){
        //             query['type'] = type;
        //             query['category'] = category;
        //         }else if(_categories.size > 0){
        //             query['category'] = category;
        //         }else if(query.product_type !== null && query.product_type !== ''){
        //             query['category'] = query.product_type;
        //         }
        //     }
        // }else 
        if(query.hasOwnProperty('product_type_1')||query.hasOwnProperty('territory_1')||query.hasOwnProperty('territory_market_1')){
            // delete query.hscStatuses
            // page = 'territories'
            // statsQueryName = V10_PROPERTIES_STATS_ACTIVE;
            // countQueryName = V10_PROPERTIES_STAT_COUNT;
            // propertiesQueryName = V10_PROPERTIES_LIST;
            // responseListKey = 'v10PropertiesList'
            // responseStatsKey = 'v10PropertiesStatsActive';
            // responseCountKey = 'v10PropertiesStatsCount'
            // /* Retriving the category and type from product type */
            let territoryProductType = groupObjectByIndex(query).map((val, idx)=>(`${val[`product_type_${idx+1}`]}`)).join(',');

            const _types = new Set();
                const _categories = new Set();
                if(territoryProductType && territoryProductType!==null && territoryProductType !==''){
                    territoryProductType.split(',').forEach((product)=>{
                        let _type = product.split(' ')
                        if(_type.length === 2){
                            _categories.add(_type[1]);
                            _types.add(_type[0]);
                        }else if(_type.length === 1){
                            _categories.add(_type[0]);
                        }
                    })
                }
                let category = '';
                let type = '';
                _categories.forEach((key)=>{category = category+','+key});
                _types.forEach((key)=>{type = type+','+key});
                category = category.replace(/^,|,$/g, '').toLowerCase()
                type = type.replace(/^,|,$/g, '')
                if(_types.size > 0){
                    query['type'] = type;
                    query['category'] = category;
                }else if(_categories.size > 0){
                    query['category'] = category;
                }else if(query.product_type !== null && query.product_type !== ''){
                    query['category'] = query.product_type.toLowerCase();
                }
                if(query['category'] && query['category'].includes('multi-family')){
                    query['category'] = query['category'] && query['category'].replace('multi-family', 'apartments');    
                }
        }
        const options = Listing.getOptions(query, page);
        options.param = stripRecordGroupListOptions(options.param);
        options.param = updateParams(options.param, 'status', 8)
        options.param = updateParams(options.param, 'type', 2)
        options.param = updateParams(options.param, 'category', 5)
        // options.param = updateParams(options.param, 'product_type', 5)
        options.param = updateParams(options.param, 'zip', 120)
        options.param = updateParams(options.param, 'market', 9)
        // options.param = updateParams(options.param, 'territory_market', 11)
        // options.param = updateParams(options.param, 'territory', 4)
        options.param = updateParams(options.param, 'state')
        if(query.hasOwnProperty('product_type_1')||query.hasOwnProperty('territory_1')||query.hasOwnProperty('territory_market_1')){
            options.param.territory_combinations = groupObjectByIndex(query)
        }
        let hscStatuses = [];
        for (const key in options.param) {
            if (key.startsWith("hsc_status_")) {
                if (options.param[key] !== "NOMATCH") {
                    hscStatuses.push(options.param[key]);
                }
            }
        }
        if(hscStatuses.length){
            options.param.hscStatuses = hscStatuses;
        }
        const sortOptions = this.parseSortOptions(query.order);
        function updateOffsetImmutable(obj, newOffset) { // due to BE response we are passing offset 0 for v7propertiesactive and count api 
            // Create a copy of the original object and update the offset
            const updatedObject = { ...obj, offset: newOffset };
            return updatedObject;
          }
          const updatedObject = updateOffsetImmutable(options.param, 0);
        if (this.client) {
            const listFetchPromise = isGroupFilterActive
                ? fetchGroupPropertyListItems(groupMemberIds).then(function(groupItems) {
                    var groupStats = computePropertyListStats(groupItems);
                    return [{
                        data: (function() {
                            var payload = {};
                            payload[responseListKey] = groupItems;
                            return payload;
                        })(),
                    }, {
                        data: (function() {
                            var payload = {};
                            payload[responseStatsKey] = [groupStats];
                            return payload;
                        })(),
                    }, {
                        data: (function() {
                            var payload = {};
                            payload[responseCountKey] = [{ count: groupItems.length }];
                            return payload;
                        })(),
                    }];
                })
                : Promise.all([
                    fetchData(propertiesQueryName, { listOptions: options.param ,sortOptions: sortOptions }),
                    fetchData(statsQueryName, { listOptions: updatedObject}),
                    fetchData(countQueryName, { listOptions: updatedObject })
                ]);

            listFetchPromise.then(values => {
                let originalItems = values[0].data[responseListKey] || [];
                originalItems.forEach(item => item.SELECTED = false);
                let statsData = values[1].data[responseStatsKey];
                let totalCount = values[2].data[responseCountKey].length > 0 ? values[2].data[responseCountKey][0].count : 0;

                let order = '';
                let orderColumn = '';
                if (query.hasOwnProperty('order')) {
                    var columnOrder = query.order;
                    if (columnOrder instanceof Array) {
                        order = 0;
                    } else {
                        order = columnOrder.split('.');
                        orderColumn = order[0];
                    }
                }
                if (query.hasOwnProperty('source') && query.source === 'STRIVE' && query.hasOwnProperty('status') && (query.status === 'In Negotiation,Under Contract' || query.status === 'Under Contract,In Negotiation')) {
                    if ((orderColumn === "STATUS" && order[1] === 'asc') || order === '') {
                        let inNgotiationItems = originalItems.filter(item => item.status === "In Negotiation");
                        inNgotiationItems.sort((a, b) => new Date(b.last_modified_date) - new Date(a.last_modified_date))
                        let underContractItems = originalItems.filter(item => item.status === "Under Contract");
                        underContractItems.sort((a, b) => new Date(b.effective_date) - new Date(a.effective_date))
                        originalItems = [...inNgotiationItems, ...underContractItems];
                    } else if (orderColumn === "STATUS" && order[1] === 'desc') {
                        let inNgotiationItems = originalItems.filter(item => item.status === "In Negotiation");
                        inNgotiationItems.sort((a, b) => new Date(a.last_modified_date) - new Date(b.last_modified_date))
                        let underContractItems = originalItems.filter(item => item.status === "Under Contract");
                        underContractItems.sort((a, b) => new Date(a.effective_date) - new Date(b.effective_date))
                        originalItems = [...underContractItems, ...inNgotiationItems];
                    }
                }
                else if ((orderColumn === "agent_1_last_name" && order[1] === 'asc') || order === '') {
                    originalItems = originalItems.sort((a, b) => {
                        const Property_1_Agent = a.agent_1_last_name || a.agent_2_last_name;
                        const Property_2_Agent = b.agent_1_last_name || b.agent_2_last_name;
                        const lastNameComaprision = Property_1_Agent ? Property_1_Agent.localeCompare(Property_2_Agent) : 0;
                        if (lastNameComaprision === 0) {
                            return a.agent_1_first_name ? a.agent_1_first_name.localeCompare(b.agent_1_first_name) : 0;
                        }
                        return lastNameComaprision;
                    });
                }

                const existingItems = cloneDeep(this.state.items);
                let items = cloneDeep(originalItems);

                const uniqueNames = new Set();
                items.forEach(obj => {
                    if (obj.lender_name) {
                        uniqueNames.add(obj.lender_name);
                    }
                });
                const uniqueNamesCount = uniqueNames.size;

                let selectedNo = 0;
                let unselectedNo = originalItems.length ? originalItems.length : 0;
                let areRemovedItems = this.state.areRemovedItems;

                if (values[0].data && areRemovedItems && query.page === this.state.query.page) {
                    let newItems = [];
                    for (let index = 0; index < originalItems.length; index++) {
                        const itemFound = existingItems.find(item => originalItems[index].arcimedes_row_id === item.arcimedes_row_id);
                        if (itemFound) {
                            newItems.push(itemFound);
                        }
                    }

                    unselectedNo = 0;
                    newItems.forEach(newItem => {
                        if (newItem.SELECTED) {
                            selectedNo++;
                        } else {
                            unselectedNo++;
                        }
                    });
                    items = newItems;
                }

                this.setState({
                    originalItems: originalItems,
                    items: items,
                    uniquePropCount: uniqueNamesCount,
                    totalCount: totalCount,
                    stats: statsData[0],
                    error: null,
                    isBusy: null,
                    query,
                    underwritingSuccess: false,
                    underwritingError: false,
                    selectedNo: selectedNo,
                    unselectedNo: unselectedNo,
                });
            });
        }
    }
    //#endregion

    componentDidUpdate(prevProps) {
        const query = this.props.location && this.props.location.query
  ? this.props.location.query
  : {};
    const PreviousQuerry = prevProps.location && prevProps.location.query
  ?prevProps.location.query
  : {};
        if (!shallowequal(PreviousQuerry, query)) {
            this.fetch(query);
            Listing.rememberListUrl();
        }
        if (this.state.comps === "lease" || this.state.comps === "sales") {
            print();
            this.setState({ comps: '' });
        }
    }
    componentWillUnmount() {
        this.setState({ comps: '' });
    }

    afterPrint() {
        this.setState({ comps: '' });
    }

    handleCheckboxChange(e) {
        let { selectedNo, unselectedNo } = this.state;
        const items = cloneDeep(this.state.items);
        const name = e.target.name;
        let _selectedAll = this.state.selectedAll;
        if (name === 'selectAll') {
            _selectedAll = !_selectedAll;
            Object.keys(items).forEach((val) => {
                if (!e.target.checked) {
                    items[val].SELECTED = true;
                    selectedNo = items.length - 2;
                    unselectedNo = 0;
                } else {
                    items[val].SELECTED = false;
                    selectedNo = 0;
                    unselectedNo = items.length - 2;
                }
            })
        }
        else {
            items[name].SELECTED = !items[name].SELECTED;
            if (items[name].SELECTED) {
                selectedNo++;
                unselectedNo--;
            } else {
                selectedNo--;
                unselectedNo++;
            }
        }
        this.setState({ items, selectedNo, unselectedNo, selectedAll: _selectedAll });
    }


    /*  removeSelected() {
         const items = this.state.items.filter(item => !item.SELECTED);
         this.setState({
            items,
             selectedNo: 0,
             areRemovedItems: true,
         });
     } */

    removeSelected() {
        const items = this.state.items.filter(item => !item.SELECTED);
        const removedItems = this.state.items.filter(item => item.SELECTED);
        let stats = {
            count: 0,
            list_price: 0,
            negotiation_price: 0,
            sold_price: 0,
            hsc_price: 0,
            sqft: 0,
            vacancy: 0,
            down_payment: 0,
            seller_fee_percentage: 0,
            net_operating_income: 0,
            close_noi: 0,
            capitalization_rate: 0,
            negotiation_cap_rate: 0,
            close_cap_rate: 0,
            rent_per_sqft: 0,
            price_per_sqft: 0,
            negotiation_price_per_sqft: 0,
            close_price_per_sqft: 0,
            total_negotiation_price: 0,
        };
        const sums = {
            list_price: 0,
            negotiation_price: 0,
            sold_price: 0,
            hsc_price: 0,
            sqft: 0,
            vacancy: 0,
            down_payment: 0,
            seller_fee_percentage: 0,
            net_operating_income: 0,
            close_noi: 0,
            capitalization_rate: 0,
            negotiation_cap_rate: 0,
            close_cap_rate: 0,
            rent_per_sqft: 0,
            price_per_sqft: 0,
            negotiation_price_per_sqft: 0,
            close_price_per_sqft: 0,
        };

        items.forEach(item => {
            if (item.status !== 'Active' || item.status === 'Active' && item.list_price) {
                for (var i = 0; i < Object.getOwnPropertyNames(stats).length; i++) {
                    var eachPropertyValue = item[Object.getOwnPropertyNames(stats)[i]];
                    if (eachPropertyValue != null && eachPropertyValue != '') {
                        stats[Object.getOwnPropertyNames(stats)[i]]++;
                    }
                }
            }
            Object.keys(sums).forEach(key => {
                sums[key] += Number(item[key]);
            });
        });
        // stats.count = items.length;

        stats.total_list_price = sums.list_price;
        stats.total_negotiation_price = sums.negotiation_price;
        stats.total_sold_price = sums.sold_price;
        stats.total_hsc_price = sums.hsc_price;
        stats.total_sqft = sums.sqft;

        if (stats.count) {
            Object.keys(sums).forEach(key => {
                stats[key] = sums[key] / stats[key];
            });
        }
        stats.count = Number(this.state.totalCount - removedItems.length);

        this.setState({ stats, selectionStats: true, totalCount: Number(this.state.totalCount - removedItems.length) });
        this.setState({
            items,
            selectedNo: 0,
            areRemovedItems: true,
        });
    }
    deleteSelected() {
        this.setState({ showConfirm: true })
    }

    removeUnselected() {
        const items = this.state.items.filter(item => item.SELECTED);

        const removedUnselectedItems = this.state.items.filter(item => item.SELECTED);
        let stats = {
            count: 0,
            list_price: 0,
            negotiation_price: 0,
            sold_price: 0,
            hsc_price: 0,
            sqft: 0,
            vacancy: 0,
            down_payment: 0,
            seller_fee_percentage: 0,
            net_operating_income: 0,
            close_noi: 0,
            capitalization_rate: 0,
            negotiation_cap_rate: 0,
            close_cap_rate: 0,
            rent_per_sqft: 0,
            price_per_sqft: 0,
            negotiation_price_per_sqft: 0,
            close_price_per_sqft: 0,
            total_negotiation_price: 0,
        };
        const sums = {
            list_price: 0,
            negotiation_price: 0,
            sold_price: 0,
            hsc_price: 0,
            sqft: 0,
            vacancy: 0,
            down_payment: 0,
            seller_fee_percentage: 0,
            net_operating_income: 0,
            close_noi: 0,
            capitalization_rate: 0,
            negotiation_cap_rate: 0,
            close_cap_rate: 0,
            rent_per_sqft: 0,
            price_per_sqft: 0,
            negotiation_price_per_sqft: 0,
            close_price_per_sqft: 0,
        };

        items.forEach(item => {
            if ((item.status !== 'Active' || item.status === 'Active') && item.list_price) {
                // stats.count++;
                for (var i = 0; i < Object.getOwnPropertyNames(stats).length; i++) {
                    var eachPropertyValue = item[Object.getOwnPropertyNames(stats)[i]];
                    if (eachPropertyValue != null && eachPropertyValue != '') {
                        stats[Object.getOwnPropertyNames(stats)[i]]++;
                    }
                }
            }
            Object.keys(sums).forEach(key => {
                sums[key] += Number(item[key]);
            });
        });
        stats.count =  items && items.length ? items.length : 0
        stats.total_list_price = sums.list_price;
        stats.total_negotiation_price = sums.negotiation_price;
        stats.total_sold_price = sums.sold_price;
        stats.total_hsc_price = sums.hsc_price;
        stats.total_sqft = sums.sqft;

        // if (stats.count) {
        //     Object.keys(sums).forEach(key => {
        //         stats[key] = sums[key] / stats[key];
        //     });
        // }
     if (stats.count) {
    Object.keys(sums).forEach(key => {
        const numerator = parseFloat(sums[key]);
        const denominator = parseFloat(stats[key]);

        if (!isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
            stats[key] = numerator / denominator;
        } else {
            stats[key] = 0;
        }
    });
}

        this.setState({
            items,
            unselectedNo: 0,
            areRemovedItems: false,
            stats,
            selectionStats: true,
            totalCount: Number(this.state.totalCount - removedUnselectedItems.length)
            // totalCount: Number(removedUnselectedItems.length)
        });

    }

   async reset() {
        const originalItems = this.state.originalItems;
        if (this.state.selectionStats) {
            this.setState({ isBusy: true });

            const query = Listing.setQueryOrder(this.state.query);
            const options = Listing.getOptions(query);
            options.param = this.updateStatus(options.param)

            function updateOffsetImmutable(obj, newOffset) { // due to BE response we are passing offset 0 for v7propertiesactive and count api 
                // Create a copy of the original object and update the offset
                const updatedObject = { ...obj, offset: newOffset };
                return updatedObject;
              }
              let updatedObject = updateOffsetImmutable(options.param, 0);
            const token = localStorage.getItem('authToken');
            const statsQueryName = query.hasOwnProperty('source') && query.source === 'STRIVE' && query.hasOwnProperty('status') && query.status === 'Active' ? V7_PROPERTIES_STATS_ACTIVE_DEV : V7_PROPERTIES_STATS_QUERY;
        //     executeQuery({ queryName: statsQueryName, options, expireTime: 1000 * 10 }).then(res => {
        //         this.setState({
        //             isBusy: null,
        //             stats: res.data[0],
        //             items: cloneDeep(originalItems),
        //             selectedNo: 0,
        //             unselectedNo: originalItems.length,
        //             areRemovedItems: false,
        //             selectionStats: false,
        //         });
        //     });
        //     return;
        // }
        const transformInput = (input) => {
            const status = Object.keys(input)
              .filter(key => key.startsWith("status_")) // Filter keys that start with "status_"
              .sort((a, b) => a.localeCompare(b))      // Ensure the keys are in the correct order
              .map(key => input[key]);                 // Map the values of the filtered keys
              const {
                status_1, status_2, status_3, status_4,
                status_5, status_6, status_7, status_8,
                status: existingStatus, // If there's already a `status` field, exclude it
                ...rest
              } = input;
            return {
              ...rest,
              status,
            };
          };
          const StatsActiveOptions = transformInput(options.param);
        const paramOptions = statsQueryName.definitions[0].name.value == "v7PropertiesStats" ? {
            pageOptions:{
                "page": 1,
                "pageSize": options.param.limit
            }
        } : {
            listOptions:StatsActiveOptions
        }
        updatedObject = updateParams(updatedObject, 'status', 8)
        updatedObject = updateParams(updatedObject, 'type', 2)
        updatedObject = updateParams(updatedObject, 'category', 5)
        updatedObject = updateParams(updatedObject, 'product_type', 5)
        updatedObject = updateParams(updatedObject, 'zip', 120)
        updatedObject = updateParams(updatedObject, 'market', 9)
        updatedObject = updateParams(updatedObject, 'territory_market', 11)
        updatedObject = updateParams(updatedObject, 'territory', 4)
        if (this.client) {
            // this.client.query({
            //     query: statsQueryName,variables: {listOptions:updatedObject}, fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     },
            // })
            fetchData(statsQueryName, {listOptions:updatedObject})
            .then(res => {
                    this.setState({
                        isBusy: null,
                        stats: res.data.v7PropertiesStatsActive ? res.data.v7PropertiesStatsActive[0] : res.data.v7PropertiesStats[0],
                        items: cloneDeep(originalItems),
                        selectedNo: 0,
                        unselectedNo: originalItems.length,
                        areRemovedItems: false,
                        selectionStats: false,
                    });
                }).catch((error)=>{console.log("while reset error : ", error)});
            }
    }


        this.setState({
            items: cloneDeep(originalItems),
            selectedNo: 0,
            unselectedNo: originalItems.length,
            areRemovedItems: false,
            selectionStats: false,
        });
    }

    updateStats() {
        const stats = {
            count: 0,
            list_price: 0,
            negotiation_price: 0,
            sold_price: 0,
            hsc_price: 0,
            sqft: 0,
            vacancy: 0,
            down_payment: 0,
            seller_fee_percentage: 0,
            net_operating_income: 0,
            close_noi: 0,
            capitalization_rate: 0,
            negotiation_cap_rate: 0,
            close_cap_rate: 0,
            rent_per_sqft: 0,
            price_per_sqft: 0,
            negotiation_price_per_sqft: 0,
            close_price_per_sqft: 0,
        };
        const sums = {
            list_price: 0,
            negotiation_price: 0,
            sold_price: 0,
            hsc_price: 0,
            sqft: 0,
            vacancy: 0,
            down_payment: 0,
            seller_fee_percentage: 0,
            net_operating_income: 0,
            close_noi: 0,
            capitalization_rate: 0,
            negotiation_cap_rate: 0,
            close_cap_rate: 0,
            rent_per_sqft: 0,
            price_per_sqft: 0,
            negotiation_price_per_sqft: 0,
            close_price_per_sqft: 0,
        };
        const items = this.state.items;

        items.forEach(item => {
            if (item.status !== 'Active' || item.status === 'Active' && item.list_price) {
                stats.count++;
                for (var i = 0; i < Object.getOwnPropertyNames(stats).length; i++) {
                    var eachPropertyValue = item[Object.getOwnPropertyNames(stats)[i]];
                    if (eachPropertyValue != null && eachPropertyValue != '') {
                        stats[Object.getOwnPropertyNames(stats)[i]]++;
                    }
                }
            }
            Object.keys(sums).forEach(key => {
                sums[key] += Number(item[key]);
            });
        });

        stats.total_list_price = sums.list_price;
        stats.total_negotiation_price = sums.negotiation_price;
        stats.total_sold_price = sums.sold_price;
        stats.total_hsc_price = sums.hsc_price;
        stats.total_sqft = sums.sqft;

        if (stats.count) {
            Object.keys(sums).forEach(key => {
                //stats[key] = sums[key] / stats.count;
                stats[key] = sums[key] / stats[key];
            });
        }

        //this.setState({stats, selectionStats: true});
        this.setState({ stats, selectionStats: true, totalCount: Number(this.state.totalCount - removedItems.length) });
    }
    selectSaleComps() {
        this.setState({ comps: 'sales' });
        this.setState((prevState) => ({
            comps: "sales"
        }));
        this.forceUpdate()
    }
    selectLeaseComps() {
        this.setState((prevState) => ({
            comps: "lease"
        }));
        this.forceUpdate()
    };

    handleChangeDropdown(hscquery, optionType, value, valueKey) {
        hscquery.hsc_team_members = hscquery[valueKey];
        const _query = this.state.query;
        _query.hsc_team_members = hscquery[valueKey];
        this.setState({ hscquery, query: _query }, () => {
            this.fetch(this.state.query);
        })
    }
    async onCloseConfirm(val) {
        if (val) {
            const items = [];
            const deletedItems = [];
            this.state.items.filter(item => item.SELECTED).forEach((e) => {
                let obj = {}
                obj["arcimedes_row_id"] = e.arcimedes_row_id;
                obj["credits_at_closing"] = e.credits_at_closing;
                obj["hsc_total_fee"] = e.hsc_total_fee;
                obj["deleted"] = 1;
                items.push(obj);
            });
            this.state.items.filter(item => item.SELECTED).forEach((e) => {
                let obj = {}
                obj["arcimedes_row_id"] = e.arcimedes_row_id;
                obj["deleted"] = 1;
                deletedItems.push(obj);
            });
            if(this.client){
                try {
                    const token = localStorage.getItem('authToken');
                    // const res = await this.client.query({
                    //     query: DELETE_PROPERTIES,
                    //     variables: { inputs: deletedItems },
                    //     context: {
                    //       headers: {
                    //         authorization: `Bearer ${token}`,
                    //       },
                    //     },
                    //   });
                      const res = await fetchData(DELETE_PROPERTIES, { inputs: deletedItems })
                      if(res.data.deleteProperties.success){
                        this.fetch(this.props.location.query);
                        window.history.replaceState(null, '');  
                      this.setState({ showConfirm: false })
                      }
                }catch (error) {
                    console.error("Error while deleting:", error);
                  }
            }
        }
        else {
            this.setState({ showConfirm: false })
        }

    }

    render() {
        const locationState = (this.props.location && this.props.location.state) || {};
        const error =  locationState.error;
        const success = locationState.success;
        const { items, originalItems, totalCount, stats, isBusy, query, checkboxes, selectedNo, unselectedNo, areRemovedItems, uniquePropCount } = this.state;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                        const query =
                          this.props.location && this.props.location.query
                            ? this.props.location.query
                            : {};
                        this.fetch(query);
                    }
                    return (
                      <div className="Listing" data-is-busy={isBusy}>
                        <div className="page-rounded-corner-container">
                          <div className="page-header-container list">
                            <ConfirmationDialog
                              open={this.state.showConfirm}
                              onClose={this.onCloseConfirm}
                            />
                            <ListStats
                              stats={stats}
                              query={query}
                              uniquePropCount={uniquePropCount}
                            />
                            <div
                              className="page-header list"
                              style={{
                                justifyContent: "space-between",
                                height: "52px",
                              }}
                            >
                              <div
                                className="page-title"
                                style={{ display: "flex" }}
                              >
                                Properties
                                {isAgentUser(this.props.userData) ? (
                                  <div
                                    style={{
                                      margin: "10px",
                                      pointerEvents: "none",
                                      opacity: 0.5,
                                    }}
                                    className="button-new plus positive"
                                  >
                                    <Icon svg={plus} />
                                  </div>
                                ) : (
                                  <LinkComp
                                    to={{
                                      pathname: `${arc.path.base}property`,
                                      state: {
                                        fromListUrl:
                                          window.location.pathname +
                                          window.location.search,
                                      },
                                    }}
                                    style={{ margin: "10px" }}
                                  >
                                    <div className="button-new plus positive">
                                      <Icon svg={plus} />
                                    </div>
                                  </LinkComp>
                                )}
                              </div>
                              {this.props.location &&
                                this.props.location.query &&
                                this.props.location.query.source === "HSC" && (
                                  <div
                                    className="Pipeline_head_right"
                                    style={{
                                      margin: "10px 0px",
                                      height: "42px",
                                    }}
                                  >
                                    <Dropdown
                                      dropdownType="multiple"
                                      optionsType="team-members"
                                      optionLabelKey="NAME"
                                      optionKey="EMAIL"
                                      value={
                                        this.state.hscquery.hsc_team_members
                                      }
                                      label="Agent"
                                      valueKey="hsc_team_members"
                                      data={this.state.hscquery}
                                      handleParentChange={
                                        this.handleChangeDropdown
                                      }
                                    />
                                  </div>
                                )}
                            </div>
                            <div className="line" />
                            <div className="buttons-container">
                              {(this.props.isSuper ||
                                (this.props.isSeniorAgent &&
                                  this.props.location.query.source ==
                                    "External" &&
                                  (this.props.location.query.status ==
                                    "Active" ||
                                    this.props.location.query.status ==
                                      "Closed")) ||
                                (this.props.isAgent &&
                                  this.props.location.query.source ==
                                    "External")) && (
                                <button
                                  className={`button-new positive ${
                                    !selectedNo ? "inactive" : ""
                                  }`}
                                  //{((this.props.isSuper) || (this.props.isSeniorAgent && (this.props.location.query.source == "External" && (this.props.location.query.status == "Active" || this.props.location.query.status == "Closed")))) && <button className={`button-new positive ${!selectedNo ? "inactive" : ""}`}
                                  style={{ width: "auto", padding: "0px 20px" }}
                                  onClick={this.deleteSelected}
                                  title="Delete Selected"
                                >
                                  <Icon
                                    svg={trash}
                                    style={{ display: "inline" }}
                                  />
                                </button>
                              )}
                              <button
                                className={`button-new text ${
                                  !selectedNo || selectedNo === items.length
                                    ? "inactive"
                                    : ""
                                }`}
                                onClick={this.removeSelected}
                              >
                                Remove Selected
                              </button>
                              <button
                                className={`button-new text ${
                                  !unselectedNo || unselectedNo === items.length
                                    ? "inactive"
                                    : ""
                                }`}
                                onClick={this.removeUnselected}
                              >
                                Remove Unselected
                              </button>
                              <button
                                className={`button-new text ${
                                  items.length !== originalItems.length
                                    ? ""
                                    : "inactive"
                                }`}
                                onClick={this.reset}
                              >
                                Reset List
                              </button>
                              <button
                                className={`button-new text ${
                                  areRemovedItems ? "" : "inactive"
                                }`}
                                onClick={this.updateStats}
                              >
                                Show Page Stats
                              </button>
                              <button
                                className={`button-new text`}
                                onClick={this.selectSaleComps}
                              >
                                Sale Comps
                              </button>
                              <button
                                className={`button-new text`}
                                onClick={this.selectLeaseComps.bind(this)}
                              >
                                Lease Comps
                              </button>
                            </div>
                          </div>
                        </div>
                        <Print
                          comps={this.state.comps}
                          location={this.props.location}
                          listings={items}
                          isHscAgent={
                            this.props.userData &&
                            this.props.userData.email &&
                            this.props.userData.email &&
                            ["@highstcapital.com", "@athenacapitalre.com"].some(
                              (domain) =>
                                this.props.userData.email.includes(domain),
                            )
                          }
                        />
                        {error ? <Alert type="error">{error}</Alert> : null}
                        {success ? (
                          <Alert type="success">{success}</Alert>
                        ) : null}

                        <div className="page-body-container">
                          <ListTable
                            location={this.props.location}
                            listings={items}
                            isSuper={this.props.isSuper}
                            isAgent={this.props.isAgent}
                            isSeniorAgent={ this.props.isSeniorAgent }
                            checkboxes={checkboxes}
                            toggleCheckbox={this.handleCheckboxChange}
                            selectedAll={this.state.selectedAll}
                            toggleAllCheckbox={this.handleCheckboxChange}
                            lastVisited={this.state.lastVisited}
                          />
                          <ListResults
                            query={
                              this.props.location && this.props.location.query
                                ? this.props.location.query
                                : {}
                            }
                            pathname={
                              this.props.location &&
                              this.props.location.pathname
                                ? this.props.location.pathname
                                : ""
                            }
                            error={this.state.error}
                            totalCount={totalCount}
                            itemCount={items ? items.length : false}
                            originalItemCount={
                              originalItems ? originalItems.length : false
                            }
                            limit={limit}
                            className="properties"
                          />
                        </div>
                      </div>
                    );
                }}
            </ApolloConsumer>

        );
    }
}